export default __webpack_public_path__ + "static/media/iitk-logo.9a9bffee.jpg";